// KYT Yapı Teknolojileri — kurumsal içerik (Türkçe). Kaynak: SON YENI.pdf

export const company = {
  name: "KYT Yapı Teknolojileri",
  legal: "KYT Yapı Teknolojileri İnşaat Mühendislik San. ve Tic. Ltd. Şti.",
  tagline: "Elektrik & Mühendislik",
  taglineEn: "Electrical & Engineering",
  since: 1993,
  phone: "0262 332 01 96",
  phoneHref: "+902623320196",
  email: "info@kytyapi.com",
  address: "Yenidoğan, Gecefası Sokak No: 10, 41100 İzmit / Kocaeli",
  addressShort: "İzmit / Kocaeli",
  mapsQuery: "Yenidoğan, Gecefası Sokak No 10, 41100 İzmit Kocaeli",
  catalog: "/katalog-kyt.pdf",
};

export const stats = [
  { value: "1993", label: "Kuruluş Yılı", suffix: "", static: true },
  { value: "30", label: "Yıllık Tecrübe", suffix: "+" },
  { value: "42", label: "Tamamlanan Proje", suffix: "+" },
  { value: "100", label: "Milyon $ İş Hacmi", suffix: "M+" },
];

export const vision = {
  title: "Vizyonumuz",
  text: "Türkiye ve dünya elektrik sektöründe mühendislik, müşavirlik, taahhüt ve satış konularında iş yapan öncü firmalar arasında yer almak.",
  extra:
    "Sıcak, samimi ve uzun yıllara dayanan iş tecrübesine sahip; işini severek yapan, gurur duyacağımız iş sayısını artıran ve her aşamada sizi gülümseten bir ekiple çalışırsınız. Para kazanmak değil; Müşteri ve Dost kazanmak en önemli felsefemizdir.",
};

export const mission = {
  title: "Misyonumuz",
  items: [
    "Girişimcilerin elektrik enerjisini verimli ve güvenli kullanmalarını sağlamak.",
    "Elektrikle ilgili her türlü taahhüt işini zamanında, hatta zamanından önce sorunsuz olarak tamamlamak.",
    "Uzman kadromuzla yıllarca kullanılabilen enerji dağıtım sistemleri kurmak.",
  ],
};

export const activityAreas = {
  title: "Faaliyet Alanlarımız",
  intro:
    "Belirlenmiş standartlardan kesinlikle taviz vermeden; konusunda uzman teknik kadromuz ve bilinçli bir sorumluluk anlayışı ile hizmet veriyoruz. Gelişen teknolojik yeniliklere, araştırma ve eğitime uyum sağlayarak gelişmeyi her zaman temel ilke olarak benimsiyoruz.",
  items: [
    "Elektrik Plan, Proje ve Taahhüt",
    "Altyapı Uygulamaları",
    "Kablolama ve Sonlandırma",
    "Test ve Otomasyon Hizmetleri",
    "Elektrik Malzemeleri Satışı",
  ],
};

export const services = {
  title: "Elektrik Taahhüt ve Proje Hizmetleri",
  titleEn: "Electrical Contracting and Project Services",
  intro:
    "Danışmanlıktan devreye almaya kadar elektrik ve mühendislik alanında uçtan uca çözümler sunuyoruz.",
  items: [
    "Danışmanlık, Planlama ve Montaj",
    "Modernizasyon ve Devreye Alma Hizmetleri",
    "Endüstriyel tesislerde Elektrik, Enstrüman ve Elektromekanik tesisat tasarım ve uygulamaları",
    "Elektrik Dağıtım ve Kumanda Panoları",
    "OG Enerji Nakil Hatları, Trafo Postaları Tasarım ve Uygulamaları",
    "Kompanzasyon Sistemleri",
    "Aydınlatma Sistemleri",
    "Topraklama ve Paratoner Sistemleri",
    "Elektrik Arıza, Bakım ve Onarım",
    "Güvenlik Sistemleri",
    "Çevre Güvenlik Otomasyonu",
    "CCTV Otomasyonu",
    "Geçiş Kontrol Sistemleri",
    "Bina Otomasyon Sistemleri",
    "Yangın İhbar Sistemleri",
    "İzleme ve Dağıtım Sistemleri",
  ],
};

export const certificates = [
  {
    code: "ISO 9001:2015",
    name: "Kalite Yönetim Sistemi",
    desc: "Tasarım, Mühendislik ve Taahhüt İşleri için kalite yönetim standardı.",
  },
  {
    code: "ISO 14001:2015",
    name: "Çevre Yönetim Sistemi",
    desc: "İnşaat, Mühendislik ve Taahhüt İşlerinde çevresel sorumluluk standardı.",
  },
  {
    code: "OHSAS 18001:2007",
    name: "İş Sağlığı ve Güvenliği Yönetim Sistemi",
    desc: "İş sağlığı ve güvenliği yönetimi için uluslararası standart.",
  },
];

export const categories = [
  { slug: "all", name: "Tüm Projeler" },
  { slug: "saglik", name: "Sağlık Merkezleri" },
  { slug: "stadyum", name: "Stadyum & Spor" },
  { slug: "avm", name: "Alışveriş Merkezleri" },
  { slug: "endustriyel", name: "Endüstriyel Tesisler" },
  { slug: "sosyal", name: "Sosyal & Yönetim Binaları" },
  { slug: "egitim", name: "Eğitim Binaları" },
  { slug: "turizm", name: "Turizm Tesisleri" },
  { slug: "konut", name: "Konutlar" },
];

export const categoryName = (slug) =>
  (categories.find((c) => c.slug === slug) || {}).name || slug;

export const sectionHeroes = {
  saglik: "/sections/hero-hospital.jpg",
  stadyum: "/sections/hero-stadium.jpg",
  endustriyel: "/sections/hero-industrial.jpg",
  sosyal: "/sections/hero-sanayi.jpg",
  turizm: "/sections/hero-turizm.jpg",
  avm: "/sections/hero-avm.jpg",
};

// PDF kataloğundaki bölüm sayfalarında listelenen, ayrı galeri sayfası olmayan
// ek referanslarımız (firma adı + lokasyon).
export const references = [
  { name: "Ege Yatırım", loc: "İstanbul" },
  { name: "Rotary Çocuk Evi", loc: "İstanbul" },
  { name: "İgsaş Güney San. A.Ş.", loc: "Kocaeli" },
  { name: "İktisat Bankası", loc: "Türkiye Geneli" },
  { name: "Kordsa", loc: "Kocaeli" },
  { name: "Şener Arda İnşaat İş Ortaklığı", loc: "Kocaeli" },
  { name: "Karpet Ltd. Şti.", loc: "Kocaeli" },
  { name: "Emlak Bank", loc: "Adapazarı" },
  { name: "Shell", loc: "Yalova" },
  { name: "Erenkaya İnşaat", loc: "Kocaeli" },
  { name: "Marmara Transport Gemi San. A.Ş.", loc: "Kocaeli" },
  { name: "Karşıyaka Sağlık Ocağı", loc: "Kocaeli" },
  { name: "Kentsa Sağlık Evi", loc: "Kocaeli" },
  { name: "Özel Kocaeli Kampüsü", loc: "Kocaeli" },
  { name: "Riva Konakları Koop.", loc: "İstanbul" },
  { name: "Şile Evleri Yapı Koop.", loc: "İstanbul" },
  { name: "Akbahçe Evleri", loc: "Yalova" },
  { name: "Akbahçe Birlik Yapı Koop.", loc: "İstanbul" },
  { name: "Onurcan Yapı Koop.", loc: "Kocaeli" },
  { name: "Kentsa A.Ş.", loc: "Kocaeli" },
  { name: "Değirmendere Belediyesi", loc: "Kocaeli" },
  { name: "Anadolu Yapı Ltd. Şti.", loc: "Kocaeli" },
  { name: "Kafkas İnşaat Ltd. Şti.", loc: "Kocaeli" },
  { name: "S.S. Rüyam Kartepe Koop.", loc: "Muğla" },
  { name: "Alarko A.Ş.", loc: "İstanbul" },
  { name: "Tekfen İnşaat A.Ş.", loc: "İstanbul" },
  { name: "Bahçekent Villaları", loc: "Kocaeli" },
];
